// The node's stream sends its status every second and meters five times a
// second. EventSource reports an error only when the connection fails, not
// when bytes stop on one still open (a laptop roaming between access
// points, a NAT dropping the mapping, a stalled proxy): the page stayed
// "connected", its dots and bars frozen on the last state (WEB-28).
// Silent past STALE_MS the page says disconnected; past DEAD_MS it drops
// the stream and connects again (catching up on events by id).
export const STALE_MS = 5000
export const DEAD_MS = 15000

export type StreamHealth = 'ok' | 'stale' | 'dead'

export function streamHealth(lastAt: number, now: number): StreamHealth {
    const quiet = now - lastAt
    if (quiet > DEAD_MS) return 'dead'
    if (quiet > STALE_MS) return 'stale'
    return 'ok'
}
